<script setup>
/**
 * The date sorter shown on full listing pages (events / retrospect / media).
 * Default keeps the curated portal order; the two date modes re-sort the
 * already-resolved list client-side (the site is static, so no refetch).
 */
const { t } = useI18n();

defineProps({ modelValue: { type: String, required: true } });
const emit = defineEmits(["update:modelValue"]);
</script>

<template>
  <label class="inline-flex items-center gap-2 text-sm text-muted">
    <svg class="h-4 w-4 shrink-0" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path d="M5 3v10m0 0L2.5 10.5M5 13l2.5-2.5M11 13V3m0 0L8.5 5.5M11 3l2.5 2.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    <span class="sr-only">{{ t("common.sort.label") }}</span>
    <select
      :value="modelValue"
      class="cursor-pointer rounded-full border border-line/70 bg-paper px-3.5 py-1.5 text-sm font-medium text-ink shadow-soft outline-none transition-colors hover:border-brand-green/50 focus:border-brand-green focus:ring-2 focus:ring-brand-green/20"
      @change="emit('update:modelValue', $event.target.value)"
    >
      <option value="default">{{ t("common.sort.default") }}</option>
      <option value="newest">{{ t("common.sort.newest") }}</option>
      <option value="oldest">{{ t("common.sort.oldest") }}</option>
    </select>
  </label>
</template>
